import { baseIntegumentarySchema } from '../validations/shared/integumentary';
const shape = baseIntegumentarySchema.shape;
export const integumentaryWnlFields = [{ key: 'wnl', field: shape.wnl }];
export const integumentaryFields = [
    { key: 'details', field: shape.details, variant: 'tags' },
    { key: 'woundsPresent', field: shape.woundsPresent },
    { key: 'narrative', field: shape.narrative },
];
